function isErrorObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function isErrorMessageList(value: unknown): value is string[] {
  return (
    Array.isArray(value) &&
    value.every((item: unknown) => typeof item === "string")
  );
}

export function getInvoiceGenerationErrorMessage(data: unknown): string {
  if (!isErrorObject(data)) {
    throw new Error("Invalid invoice generation error response");
  }

  if (isErrorObject(data.errors)) {
    const messages: string[] = [];
    for (const fieldErrors of Object.values(data.errors)) {
      if (!isErrorMessageList(fieldErrors)) {
        throw new Error("Invalid invoice generation validation errors");
      }
      messages.push(...fieldErrors);
    }
    if (messages.length > 0) {
      return messages.join(" ");
    }
  }

  if (typeof data.message === "string" && data.message.length > 0) {
    return data.message;
  }

  throw new Error("Invoice generation error response has no message");
}
